<div class="relative">
  <ng-container *ngIf="isLoading; else loadedReviews">
    <div
      [thkLibProcessing]="isLoading"
      [size]="'lg'"
      variant="primary"
      class="flex aspect-[7/3] w-full items-center justify-center bg-black"
    ></div>
  </ng-container>
  <ng-template #loadedReviews>
    <ng-container *ngIf="currentActivity; else noActivity">
      <ng-container *ngTemplateOutlet="activity"></ng-container>
    </ng-container>
    <ng-template #noActivity>
      <ng-container *ngTemplateOutlet="emptyActivity"></ng-container>
    </ng-template>
  </ng-template>
</div>

<ng-template #activity>
  <app-learning-lab-activity-video
    (event)="activityHandler($event)"
    *ngIf="currentActivity.type === 'lecture' && currentActivity.lecture?.type === 'video'"
    [hidePrev]="prev.length ? false : true"
    [hideNext]="next.length ? false : true"
    [prevData]="prevData"
    [nextData]="nextData"
  ></app-learning-lab-activity-video>
  <app-learning-lab-activity-article
    (event)="activityHandler($event)"
    *ngIf="currentActivity.type === 'lecture' && currentActivity.lecture?.type === 'article'"
    [hidePrev]="prev.length ? false : true"
    [hideNext]="next.length ? false : true"
  ></app-learning-lab-activity-article>
  <app-learning-lab-activity-quiz 
    (event)="activityHandler($event)" 
    *ngIf="currentActivity.type === 'quiz'"
    [hidePrev]="prev.length ? false : true"
    [hideNext]="next.length ? false : true"
  ></app-learning-lab-activity-quiz>
  <app-learning-lab-activity-assignment 
    (event)="activityHandler($event)" 
    *ngIf="currentActivity.type === 'assignment'"
    [hidePrev]="prev.length ? false : true"
    [hideNext]="next.length ? false : true"
  ></app-learning-lab-activity-assignment>
  <ng-container *ngIf="currentActivity.type === 'completed'">
    <ng-container *ngTemplateOutlet="completedActivity"></ng-container>
  </ng-container>
</ng-template>
<ng-template #emptyActivity>
  <div class="py-12 text-center">
    <svg-icon src="@assets/images/not-found.svg" class="mx-auto my-8 block w-72"></svg-icon>
    <h3 class="mb-3" i18n>Oh man, You don't supposed to see this!</h3>
    <p i18n>
      Please find your way to the <a href="../">homepage</a> or get help <a href="#">here</a>. And remember you didn't
      see anything!
    </p>
  </div>
</ng-template>
<ng-template #completedActivity>
  <div
    class="flex aspect-[7/3] w-full flex-col items-center justify-center overflow-hidden bg-slate-800 py-12 text-center"
  >
    <svg-icon class="animate absolute left-0 top-0 w-full opacity-0" src="@assets/images/confetti.svg"></svg-icon>
    <!-- <svg-icon src="@assets/images/career-promotion.svg" class="mx-auto my-8 block w-72"></svg-icon> -->
    <h3 class="greeting-text-animate mb-3 text-center text-5xl font-bold text-slate-500" i18n>Congratulation!</h3>
    <p class="greeting-text-animate text-center text-lg font-bold text-slate-500" i18n>
      You have successfully completed this course :)
    </p>
  </div>
</ng-template>
